import { UseCasePrioritisation } from '../../signup-data/signupDataOptions';
import { getWhichOAuthSelected } from '../../store/app/selectors';
import { ExperimentKeys } from '../ExperimentKeys';
import { Tracker } from '../../store/tracking/action-creators';
import { getParameter, isExperimentActive } from '../../store/experiments/selectors';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { Step } from 'signup-constants/Step';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { setFlow } from '../../store/flow/action-creators';
import { getIsAuthenticated } from '../../store/auth/selectors';
import { useSelector } from 'react-redux';
import { getHasExposureBeenTracked, setHasExposureBeenTracked } from '../useExperiment';
import { getTracker } from '../../tracking/getTracker';
import { EventName } from '../../tracking/EventName';
export const getHighestPriorityUseCase = useCases => {
  if (useCases.length === 1) {
    return useCases[0];
  }
  return UseCasePrioritisation.find(useCase => useCases.includes(useCase));
};
export const setFlowForCOAC0001 = ({
  stepsToRemove = [],
  isPreVerificationExistingUserSession = false
}) => dispatch => {
  const {
    postExistingAccountSelection
  } = getFlowSteps();
  const variantPreVerificationSteps = [Step.LandingPage, Step.CodeVerification];
  const variantPostAccountCreationSteps = [Step.UseCase];
  const variantPostVerificationSteps = [Step.Password, Step.Name, Step.Industry, Step.ManagementLevel, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.HubletSelection];
  const nextSteps = [...(isPreVerificationExistingUserSession ? [Step.ExistingUser] : []), ...(isPreVerification() ? variantPreVerificationSteps : []), ...variantPostVerificationSteps, ...variantPostAccountCreationSteps];
  const flowSteps = {
    nextSteps,
    variantPreVerificationSteps,
    variantPostVerificationSteps,
    variantPostAccountCreationSteps,
    postExistingAccountSelection
  };
  if (stepsToRemove.length > 0) {
    // replicating the logic inside FlowStateManager.removeSteps(stepsToRemove)
    Object.keys(flowSteps).forEach(key => {
      flowSteps[key] = NextStepManager.removeSteps(...stepsToRemove)(flowSteps[key]);
    });
  }
  dispatch(setFlow(flowSteps.nextSteps, flowSteps.variantPreVerificationSteps, flowSteps.variantPostVerificationSteps, flowSteps.variantPostAccountCreationSteps, flowSteps.postExistingAccountSelection));
  return nextSteps;
};
export const setupAuthForOAuthExistingUserCOAC0001 = (state, experimentKey, dispatch) => {
  const oAuthProviderSelected = getWhichOAuthSelected(state);
  dispatch(Tracker.signupInteraction(`${experimentKey}-${oAuthProviderSelected}-oauth-existing-user-${getParameter(state, ExperimentKeys.COAC0001)}`));
  dispatch(setFlowForCOAC0001({
    isPreVerificationExistingUserSession: getIsAuthenticated(state) && isPreVerification()
  }));
};
const checkExperimentCOAC0001Active = state => {
  return isExperimentActive(state, ExperimentKeys.COAC0001);
};
const checkExperimentCOAC0001Parameter = state => {
  return getParameter(state, ExperimentKeys.COAC0001);
};
const trackExposure = (shouldTrackExposure, parameter) => {
  const hasExposureBeenTracked = getHasExposureBeenTracked(ExperimentKeys.COAC0001);
  if (shouldTrackExposure && !hasExposureBeenTracked) {
    getTracker().track(EventName.ExperimentExposure, {
      action: `${ExperimentKeys.COAC0001}-group-${parameter}`
    }, true);
    setHasExposureBeenTracked(ExperimentKeys.COAC0001);
  }
};
export const useShouldTrackCOAC0001 = () => {
  const shouldTrackExposure = useSelector(checkExperimentCOAC0001Active);
  const parameter = useSelector(checkExperimentCOAC0001Parameter);
  const trackCOAC0001Exposure = () => {
    trackExposure(shouldTrackExposure, parameter);
  };
  return {
    trackCOAC0001Exposure
  };
};
export const trackCOAC0001ExposureForGooglePrompt = state => {
  const shouldTrackExposure = checkExperimentCOAC0001Active(state);
  const parameter = checkExperimentCOAC0001Parameter(state);
  trackExposure(shouldTrackExposure, parameter);
};